import { Component } from '@angular/core';

@Component({
  selector: 'app-swipes-logo',
  templateUrl: './swipes-logo.component.html',
  styleUrl: './swipes-logo.component.scss',
})
export class SwipesLogoComponent {}
